import React from "react";
import useIsMobile from "~/lib/hooks/useIsMobile";
import SignInPageMobile from "~/src/components/auth/SignInPageMobile";
import SignInPageDesktop from "~/src/components/auth/SignInPageDesktop";
interface ISignInPageProps {
  signingIn?: boolean;
  inviteToken?: string | null;
}
export default function SignInPage({ signingIn = true, inviteToken }: ISignInPageProps) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return <SignInPageMobile signingIn={signingIn} inviteToken={inviteToken} />;
  }
  return <SignInPageDesktop signingIn={signingIn} inviteToken={inviteToken} />;
}
